module.exports = __webpack_public_path__ + "static/img/downimg_en.a2352cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/honggu/downimg_en.png
// module id = s4sw
// module chunks = 88